import Icon, { ICON_LIST } from './Icon';

export { Icon, ICON_LIST };
export default Icon;
